import LayoutRoot from "@/views/layout/LayoutRoot.vue"
// 超管路由，superRoutes为侧边栏路由
let superRoutes = [{
    path: '/layout_root',
    name: 'SuperIndex',
    title: "首页",
    id: "300",
    icon: "el-icon-s-tools",
    meta: {
      role: 'super'
    },
    component: LayoutRoot,
    children: [{
      path: '/super/index',
      name: 'SuperIndex',
      title: "首页",
      icon: "el-icon-tools",
      meta: [{
        name: '首页',
        path: '/super/index',
        role: 'super'
      }],
      component: () => import('@/views/super/index/SuperIndex.vue')
    }]
  }, {
    path: '/layout_root',
    name: 'LayoutRoot',
    title: "系统中心",
    id: "301",
    icon: "el-icon-s-tools",
    meta: {
      role: 'super'
    },
    component: LayoutRoot,
    children: [{
      path: '/super/role_admin',
      name: 'SuperRoleAdmin',
      title: "角色管理",
      id: "30101",
      meta: [{
        name: '角色管理',
        path: '/super/role_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/sys-admin/RoleAdmin.vue')
    }, {
      path: '/super/account_admin',
      name: 'SuperAccountAdmin',
      title: "账号管理",
      id: "30102",
      meta: [{
        name: '账号管理',
        path: '/super/account_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/sys-admin/AccountAdmin.vue')
    }, {
      path: '/super/log_admin',
      name: 'SuperLogAdmin',
      title: "日志管理",
      id: "30103",
      meta: [{
        name: '日志管理',
        path: '/super/log_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/sys-admin/LogAdmin.vue')
    }]
  },
  {
    path: '/layout_root',
    name: 'LayoutRoot',
    title: "商户",
    id: "302",
    icon: "el-icon-s-management",
    meta: {
      role: 'super'
    },
    component: LayoutRoot,
    children: [{
      path: '/super/company_admin',
      name: 'SuperCompanyAdmin',
      title: "公司管理",
      id: "30201",
      meta: [{
        name: '公司管理',
        path: '/super/company_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/merchant-admin/CompanyAdmin.vue')
    }, {
      path: '/super/shop_admin',
      name: 'SuperShopAdmin',
      title: "门店管理",
      id: "30202",
      meta: [{
        name: '门店管理',
        path: '/super/shop_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/merchant-admin/ShopAdmin.vue')
    }]
  },
  {
    path: '/layout_root',
    name: 'LayoutRoot',
    title: "设备激活码管理",
    id: "303",
    meta: {
      role: 'super'
    },
    component: LayoutRoot,
    children: [{
      path: '/super/cdkey_admin',
      name: 'SuperCdkeyAdmin',
      title: "激活码管理",
      icon: "el-icon-link",
      id: "30301",
      meta: [{
        name: '激活码管理',
        path: '/super/cdkey_admin',
        role: 'super'
      }],
      component: () => import('@/views/super/cdkey-admin/CdkeyAdmin.vue')
    }]
  },
  //  {
  //   path: '/layout_root',
  //   name: 'LayoutRoot',
  //   title: "支付管理",
  //   id: "304",
  //   meta: {
  //     role: 'super'
  //   },
  //   component: LayoutRoot,
  //   children: [{
  //     path: '/super/pay_admin',
  //     name: 'SuperPayAdmin',
  //     title: "支付管理",
  //     icon: "el-icon-money",
  //     id:"30401",
  //     meta: [{
  //       name: '支付管理',
  //       path: '/super/pay_admin',
  //       role: 'super'
  //     }],
  //     component: () => import('@/views/super/pay-admin/PayAdmin.vue')
  //   }]
  // }, 
  {
    path: '/layout_root',
    name: 'LayoutRoot',
    title: "产品",
    id: "305",
    icon: "el-icon-box",
    meta: {
      role: 'super'
    },
    component: LayoutRoot,
    children: [{
      path: '/super/product_pricing',
      name: 'SuperProductPricing',
      title: "产品定价设置",
      id: "30501",
      meta: [{
        name: '产品定价设置',
        path: '/super/product_pricing',
        role: 'super'
      }],
      component: () => import('@/views/super/product-pricing/ProductPricing.vue')
    }, {
      path: '/super/message_pricing',
      name: 'SuperMessagePricing',
      title: "短信定价设置",
      id: "30502",
      meta: [{
        name: '短信定价设置',
        path: '/super/message_pricing',
        role: 'super'
      }],
      component: () => import('@/views/super/product-pricing/MessagePricing.vue')
    }]
  }
]
let superOtherRoutes = [{
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "商户",
  meta: {
    role: 'super'
  },
  component: LayoutRoot,
  children: [{
    path: '/super/create_role',
    name: 'SuperCreateRole',
    title: "角色管理",
    meta: [{
      name: '角色管理',
      path: '/super/role_admin',
      role: 'super'
    }, {
      name: '创建或修改角色',
      path: '/super/create_role',
      role: 'super'
    }],
    component: () => import('@/views/super/sys-admin/CreateRole.vue')
  }, {
    path: '/super/add_company',
    name: 'SuperAddCompany',
    title: "添加或修改公司",
    meta: [{
      name: '公司管理',
      path: '/super/company_admin',
      role: 'super'
    }, {
      name: '添加或修改公司',
      path: '/super/add_company',
      role: 'super'
    }],
    component: () => import('@/views/super/merchant-admin/AddCompany.vue')
  }, {
    path: '/super/pay_setting',
    name: 'SuperPaySetting',
    title: "公司管理",
    meta: [{
      name: '公司管理',
      path: '/super/company_admin',
      role: 'super'
    }, {
      name: '支付设置',
      path: '/super/pay_setting',
      role: 'super'
    }],
    component: () => import('@/views/super/merchant-admin/PaySettting.vue')
  }, {
    path: '/super/add_shop',
    name: 'SuperAddShop',
    title: "添加或修改门店",
    meta: [{
      name: '门店管理',
      path: '/super/shop_admin',
      role: 'super'
    }, {
      name: '添加或修改门店',
      path: '/super/add_shop',
      role: 'super'
    }],
    component: () => import('@/views/super/merchant-admin/AddShop.vue')
  }]
}]
// 公司管理路由，merchantRoutes为侧边栏路由
let merchantRoutes = [{
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "首页",
  id: "200",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/company_index',
    name: 'MerchantCompanyIndex',
    title: "首页",
    icon: "el-icon-s-tools",
    meta: [{
      name: '首页',
      path: '/merchant/company_index',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/index/CompanyIndex.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "系统中心",
  id: "201",
  icon: "el-icon-s-tools",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [
    // {
    //   path: '/merchant/merchant_admin',
    //   name: 'MerchantAdmin',
    //   title: "商户中心",
    //   id: "20101",
    //   meta: [{
    //     name: '商户中心',
    //     path: '/merchant/merchant_admin',
    //     role: 'merchant'
    //   }],
    //   component: () => import('@/views/merchant/sys-admin/MerchantAdmin.vue')
    // },
    {
      path: '/merchant/role_admin',
      name: 'MerchantRoleAdmin',
      title: "角色管理",
      id: "20102",
      meta: [{
        name: '角色管理',
        path: '/merchant/role_admin',
        role: 'merchant'
      }],
      component: () => import('@/views/merchant/sys-admin/RoleAdmin.vue')
    }, {
      path: '/merchant/account_admin',
      name: 'MerchantAccountAdmin',
      title: "账号管理",
      id: "20103",
      meta: [{
        name: '账号管理',
        path: '/merchant/account_admin',
        role: 'merchant'
      }],
      component: () => import('@/views/merchant/sys-admin/AccountAdmin.vue')
    },
    //  {
    //   path: '/merchant/pay_setting',
    //   name: 'MerchantPaySetting',
    //   title: "支付管理",
    //   id: "20104",
    //   meta: [{
    //     name: '支付管理',
    //     path: '/merchant/pay_setting',
    //     role: 'merchant'
    //   }],
    //   component: () => import('@/views/merchant/sys-admin/PaySetting.vue')
    // },
    {
      path: '/merchant/log_admin',
      name: 'MerchantLogAdmin',
      title: "日志管理",
      id: "20105",
      meta: [{
        name: '日志管理',
        path: '/merchant/log_admin',
        role: 'merchant'
      }],
      component: () => import('@/views/merchant/sys-admin/LogAdmin.vue')
    }
  ]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "食堂管理",
  id: "202",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/shop_admin',
    name: 'MerchantShopAdmin',
    title: "食堂管理",
    icon: "el-icon-s-shop",
    id: "20201",
    meta: [{
      name: '食堂管理',
      path: '/merchant/shop_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/shop-admin/ShopAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "菜品",
  id: "203",
  icon: "el-icon-food",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/food_classification',
    name: 'MerchantFoodClassification',
    title: "菜品分类",
    id: "20301",
    meta: [{
      name: '菜品分类',
      path: '/merchant/food_classification',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/FoodClassification.vue')
  }, {
    path: '/merchant/food_admin',
    name: 'MerchantFoodAdmin',
    title: "菜品管理",
    id: "20302",
    meta: [{
      name: '菜品管理',
      path: '/merchant/food_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/FoodAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "餐品",
  id: "206",
  icon: "el-icon-dish",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/plate_classification',
    name: 'MerchantPlateClassification',
    title: "餐盘分类",
    id: "20601",
    meta: [{
      name: '餐盘分类',
      path: '/merchant/plate_classification',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/PlateClassification.vue')
  }, {
    path: '/merchant/plate_admin',
    name: 'MerchantPlateAdmin',
    title: "餐盘管理",
    id: "20602",
    meta: [{
      name: '餐盘管理',
      path: '/merchant/plate_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/PlateAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "副食",
  id: "207",
  icon: "el-icon-dessert",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/non_staple_classification',
    name: 'MerchantNonStapleClassification',
    title: "副食分类",
    id: "20701",
    meta: [{
      name: '副食分类',
      path: '/merchant/NonStapleClassification',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/NonStapleClassification.vue')
  }, {
    path: '/merchant/non_staple_admin',
    name: 'MerchantNonStapleAdmin',
    title: "副食管理",
    id: "20702",
    meta: [{
      name: '副食管理',
      path: '/merchant/non_staple_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/NonStapleAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "订单",
  id: "204",
  icon: "el-icon-s-order",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/shop_order_admin',
    name: 'MerchantShopOrderAdmin',
    title: "食堂订单",
    id: "20401",
    meta: [{
      name: '食堂订单',
      path: '/merchant/shop_order_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/order-admin/ShopOrderAdmin.vue')
  }, {
    path: '/merchant/refund_order',
    name: 'MerchantRefundOrder',
    title: "退款订单",
    id: "20402",
    meta: [{
      name: '退款订单',
      path: '/merchant/refund_order',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/order-admin/RefundOrder.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "人脸管理",
  id: "205",
  icon: "el-icon-picture-outline-round",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/face_admin',
    name: 'MerchantFaceAdmin',
    title: "人脸列表",
    id: "20501",
    meta: [{
      name: '人脸列表',
      path: '/merchant/face_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/FaceAdmin.vue')
  }, {
    path: '/merchant/face_group',
    name: 'MerchantFaceGroup',
    title: "人脸分组",
    id: "20502",
    meta: [{
      name: '人脸分组',
      path: '/merchant/face_group',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/FaceGroup.vue')
  }, {
    path: '/merchant/face_account',
    name: 'MerchantFaceAccount',
    title: "人脸账户",
    id: "20503",
    meta: [{
      name: '人脸账户',
      path: '/merchant/face_account',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/FaceAccount.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "优惠管理",
  id: "208",
  icon: "el-icon-coin",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/dicount_admin',
    name: 'MerchantDiscountAdmin',
    title: "折扣消费",
    id: "20801",
    meta: [{
      name: '折扣消费',
      path: '/merchant/dicount_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/DiscountAdmin.vue')
  }, {
    path: '/merchant/exemption_admin',
    name: 'MerchantExemptionAdmin',
    title: "免额消费",
    id: "20802",
    meta: [{
      name: '免额消费',
      path: '/merchant/exemption_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/ExemptionAdmin.vue')
  }, {
    path: '/merchant/quota_admin',
    name: 'MerchantQuotaAdmin',
    title: "定额补贴",
    id: "20803",
    meta: [{
      name: '定额补贴',
      path: '/merchant/quota_admin',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/QuotaAdmin.vue')
  }, {
    path: '/merchant/discount_setting',
    name: 'MerchantDiscountSetting',
    title: "优惠设置",
    id: "20804",
    meta: [{
      name: '优惠设置',
      path: '/merchant/discount_setting',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/DiscountSetting.vue')
  }]
}]
let merchantOtherRoutes = [{
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "商户",
  meta: {
    role: 'merchant'
  },
  component: LayoutRoot,
  children: [{
    path: '/merchant/shop_index',
    name: 'MerchantShopIndex',
    title: "食堂概况",
    icon: "el-icon-s-shop",
    meta: [{
      name: '食堂概况',
      path: '/merchant/shop_index',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/index/ShopIndex.vue')
  }, {
    path: '/merchant/create_role',
    name: 'MerchantCreateRole',
    title: "角色管理",
    meta: [{
      name: '角色管理',
      path: '/merchant/role_admin',
      role: 'merchant'
    }, {
      name: '创建角色',
      path: '/merchant/create_role',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/sys-admin/CreateRole.vue')
  }, {
    path: '/merchant/mul_add_food',
    name: 'MerchantMulAddFood',
    title: "菜品管理",
    meta: [{
      name: '菜品管理',
      path: '/merchant/food_admin',
      role: 'merchant'
    }, {
      name: '批量添加菜品',
      path: '/merchant/mul_add_food',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/good-admin/MulAddFood.vue')
  }, {
    path: '/merchant/face_account_detail',
    name: 'MerchantFaceAccountDetail',
    title: "人脸账户",
    meta: [{
      name: '人脸账户',
      path: '/merchant/face_account',
      role: 'merchant'
    }, {
      name: '账户明细',
      path: '/merchant/face_account_detail',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/face-admin/FaceAccountDetail.vue')
  }, {
    path: '/merchant/add_shop',
    name: 'MerchantAddShop',
    title: "添加\修改食堂",
    meta: [{
      name: '食堂管理',
      path: '/merchant/shop_admin',
      role: 'merchant'
    }, {
      name: '添加\修改食堂',
      path: '/merchant/add_shop',
      role: 'merchant'
    }],
    component: () => import('@/views/merchant/shop-admin/AddShop.vue')
  }]
}]
// 食堂管理路由，shopRoutes为侧边栏路由
let shopRoutes = [{
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "首页",
  id: "100",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/index',
    name: 'ShopIndex',
    title: "首页",
    icon: "el-icon-s-tools",
    meta: [{
      name: '首页',
      path: '/shop/index',
      role: 'shop'
    }],
    component: () => import('@/views/shop/index/ShopIndex.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "系统中心",
  id: "101",
  icon: "el-icon-s-tools",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/role_admin',
    name: 'ShopRoleAdmin',
    title: "角色管理",
    id: "10101",
    meta: [{
      name: '角色管理',
      path: '/shop/role_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/sys-admin/RoleAdmin.vue')
  }, {
    path: '/shop/account_admin',
    name: 'ShopAccountAdmin',
    title: "账号管理",
    id: "10102",
    meta: [{
      name: '账号管理',
      path: '/shop/account_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/sys-admin/AccountAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "菜品",
  id: "102",
  icon: "el-icon-food",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/food_admin',
    name: 'ShopFoodAdmin',
    title: "菜品管理",
    id: "10201",
    icon: "el-icon-food",
    meta: [{
      name: '菜品管理',
      path: '/shop/food_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/good-admin/FoodAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "餐品",
  id: "106",
  icon: "el-icon-dish",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/plate_admin',
    name: 'ShopPlateAdmin',
    title: "餐盘管理",
    id: "10601",
    icon: "el-icon-dish",
    meta: [{
      name: '餐盘管理',
      path: '/shop/plate_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/good-admin/PlateAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "副食",
  id: "107",
  icon: "el-icon-dessert",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/non_staple_admin',
    name: 'ShopNonStapleAdmin',
    title: "副食管理",
    id: "10701",
    icon: "el-icon-dessert",
    meta: [{
      name: '副食管理',
      path: '/shop/non_staple_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/good-admin/NonStapleAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "订单",
  id: "103",
  icon: "el-icon-s-order",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/order_admin',
    name: 'ShopOrderAdmin',
    title: "食堂订单",
    id: "10301",
    icon: "el-icon-s-order",
    meta: [{
      name: '食堂订单',
      path: '/shop/shop_order_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/order-admin/OrderAdmin.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "人脸管理",
  id: "104",
  icon: "el-icon-picture-outline-round",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/face_admin',
    name: 'ShopFaceAdmin',
    title: "人脸列表",
    id: "10401",
    meta: [{
      name: '人脸列表',
      path: '/shop/face_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/FaceAdmin.vue')
  }, {
    path: '/shop/face_group',
    name: 'ShopFaceGroup',
    title: "人脸分组",
    id: "10402",
    meta: [{
      name: '人脸分组',
      path: '/shop/face_group',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/FaceGroup.vue')
  }, {
    path: '/shop/face_account',
    name: 'ShopFaceAccount',
    title: "人脸账户",
    id: "10403",
    meta: [{
      name: '人脸账户',
      path: '/shop/face_account',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/FaceAccount.vue')
  }]
}, {
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "优惠管理",
  id: "105",
  icon: "el-icon-coin",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/dicount_admin',
    name: 'ShopDiscountAdmin',
    title: "折扣消费",
    id: "10501",
    meta: [{
      name: '折扣消费',
      path: '/shop/dicount_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/DiscountAdmin.vue')
  }, {
    path: '/shop/exemption_admin',
    name: 'ShopExemptionAdmin',
    title: "免额消费",
    id: "10502",
    meta: [{
      name: '免额消费',
      path: '/shop/exemption_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/ExemptionAdmin.vue')
  }, {
    path: '/shop/quota_admin',
    name: 'ShopQuotaAdmin',
    title: "定额补贴",
    id: "10503",
    meta: [{
      name: '定额补贴',
      path: '/shop/quota_admin',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/QuotaAdmin.vue')
  }, {
    path: '/shop/discount_setting',
    name: 'ShopDiscountSetting',
    title: "优惠设置",
    id: "10504",
    meta: [{
      name: '优惠设置',
      path: '/shop/discount_setting',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/DiscountSetting.vue')
  }]
}]
let shopOtherRoutes = [{
  path: '/layout_root',
  name: 'LayoutRoot',
  title: "食堂其他路由",
  meta: {
    role: 'shop'
  },
  component: LayoutRoot,
  children: [{
    path: '/shop/create_role',
    name: 'ShopCreateRole',
    title: "角色管理",
    meta: [{
      name: '角色管理',
      path: '/shop/role_admin',
      role: 'shop'
    }, {
      name: '创建角色',
      path: '/shop/create_role',
      role: 'shop'
    }],
    component: () => import('@/views/shop/sys-admin/CreateRole.vue')
  }, {
    path: '/shop/mul_add_food',
    name: 'ShopMulAddFood',
    title: "菜品管理",
    meta: [{
      name: '菜品管理',
      path: '/shop/food_admin',
      role: 'shop'
    }, {
      name: '添加菜品',
      path: '/shop/mul_add_food',
      role: 'shop'
    }],
    component: () => import('@/views/shop/good-admin/MulAddFood.vue')
  }, {
    path: '/shop/face_account_detail',
    name: 'ShopFaceAccountDetail',
    title: "人脸账户",
    meta: [{
      name: '人脸账户',
      path: '/shop/face_account',
      role: 'shop'
    }, {
      name: '账户明细',
      path: '/shop/face_account_detail',
      role: 'shop'
    }],
    component: () => import('@/views/shop/face-admin/FaceAccountDetail.vue')
  }]
}]

export default {
  superRoutes,
  superOtherRoutes,
  merchantRoutes,
  merchantOtherRoutes,
  shopRoutes,
  shopOtherRoutes
}



// WEBPACK FOOTER //
// ./src/router/routesMap.js